import React from "react";
import {createRoot} from "react-dom/client";
import "./AppStyle.css";
import AppRoutes from "./AppRoutes";


const container = document.getElementById('app')
const root = createRoot(container)

root.render(<AppRoutes/>)

